<div [class]="'border border-md border-primary empty-data-banner ' + orientation">
  <img *ngIf="imageUrl" class="empty-data-banner__image" alt="empty data banner" [src]="imagePath" />
  <div [class]="'empty-data-banner__data ' + orientation">
    <h2 *ngIf="title" class="empty-data-banner__title">{{ title }}</h2>
    <span *ngIf="description" class="empty-data-banner__description">{{ description }}</span>
    <div *ngIf="actionLabel" class="empty-data-banner__actions">
      <button
        type="button"
        sparkButton
        size="large"
        class="w-full"
        data-testid="qa-empty-data-banner"
        (click)="onActionClicked()"
      >
        {{ actionLabel }}
      </button>
    </div>
  </div>
</div>
